import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import ApplicationAdapter from 'lumen/adapters/application';
import type { HotelAndMarketServiceWithMarket } from 'lumen/services/hotel-and-market';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';

const DEFINITIONS_BASE = `property-tags/custom/definitions`;

export default class CustomTagDefinitionAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithMarket;

  namespace = APIGATEWAY;

  override buildURL(
    modelName: string,
    id: string | null,
    snapshot: Parameters<ApplicationAdapter['buildURL']>[2],
    requestType?: string,
  ): string {
    // @ts-expect-error: ApplicationAdapter type declares 3 params but runtime accepts requestType as 4th
    const url = super.buildURL(modelName, id, snapshot, requestType);
    if (
      requestType &&
      ['createRecord', 'updateRecord', 'deleteRecord'].includes(requestType)
    ) {
      const marketId = this.hotelAndMarketService.market?.id;
      if (marketId) {
        return `${url}?market_id=${marketId}`;
      }
    }
    return url;
  }

  pathForType(): string {
    return DEFINITIONS_BASE;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  query(store: Store, type: ModelSchema, query: Record<string, unknown>) {
    return this.handleQuery(store, type, { ...query, namespace: APIGATEWAY });
  }

  urlForCreateRecord(): string {
    return `${this.host}/${APIGATEWAY}/${DEFINITIONS_BASE}`;
  }

  urlForDeleteRecord(id: string): string {
    return `${this.host}/${APIGATEWAY}/${DEFINITIONS_BASE}/${id}`;
  }

  urlForUpdateRecord(id: string): string {
    return `${this.host}/${APIGATEWAY}/${DEFINITIONS_BASE}/${id}`;
  }
}
